export const getHappinessColor = (score?: number | null): string => {
  switch (score) {
    case 1:
      return '#FF1502';
    case 2:
      return '#FF4802';
    case 3:
      return '#FE7D00';
    case 4:
      return '#FFAF00';
    case 5:
      return '#ecd200';
    case 6:
      return '#c7d001';
    case 7:
      return '#B4DC02';
    case 8:
      return '#83C001';
    case 9:
      return '#4BA601';
    case 10:
      return '#198C00';
    default:
      return '#ffffff';
  }
};
